export default __webpack_public_path__ + "static/Rita Lywczek-3c65e00eccf13afb2b0446e6b5eef292.png";